// src/AuthForm.js
import React, { useState, useContext, useEffect } from 'react';
// import '../css/App.css';
// import '../css/Login.css';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import APIClient from '../common/ApiClient';
import { toast } from "react-toastify";

const AuthForm = () => {
  // const [isLoading, setIsLoading] = useState(false);
  const [formType, setFormType] = useState('login');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const { setAuth } = useContext(AuthContext);
  useEffect(() => {
    const oData = localStorage.getItem('userInfo');
    if (JSON.parse(oData)) {
      setAuth(JSON.parse(oData));
      navigate("/home");
    }
  }, [setAuth, navigate]);


  const handleSubmit = (event) => {
    event.preventDefault();

    if (formType === 'signup' && password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setError('');

    if (formType === 'signup') {
      APIClient.post('/signup', {
        name: name,
        email: email,
        pwd: password,
        confPassword: confirmPassword
      })
        .then(response => {
          setError(response.data.message);
          // setIsLoading(false);
        })
        .catch(error => {
          setError(error.code + ':' + error.message);
          // setIsLoading(false);
        });
    } else if (formType === 'login') {
      APIClient.post('/login', {
        email: email,
        pwd: password
      })
        .then(response => {
          setAuth(response.data);
          // setIsLoading(false);
          navigate("/home");
        })
        .catch(error => {
          var msg = "";
          if (error.response) {
            msg = error.response.data.message
          } else {
            msg = error.code + ':' + error.message
          }
          setError(msg);
          // setIsLoading(false);
        });
    } else if (formType === 'forgotPwd') {
      
      APIClient.post('/sendForgotPwdMail', {
        email: email
      }).then(response => {
        toast.success(response.data.message, {
          position: "bottom-center",
          pauseOnHover: true,
          delay: true
        });
      }).catch(error => {
        var msg = "";
          if (error.response) {
            msg = error.response.data.message
          } else {
            msg = error.code + ':' + error.message
          }
          setError(msg);
      });

    }
  };

  const onSwitch = (oEvent) => {
    setFormType((formType) => (formType === 'login' ? 'signup' : 'login'));
    setError('');
  };
  const onForgotPwd = () => {
    setFormType('forgotPwd');
    setError('');
  }

  return (
    <div className='login-container'>
      {/* <BusyIndicator /> */}
      {/* {isLoading && <BusyIndicator />} */}
      <div className="auth-form">
        <img src="/images/logo-dblue.png" alt="logo" style={{ maxWidth: '400px', width: '100%', height: 'auto', borderRadius: '5px' }} />
        <h2>{formType === 'login' ? 'Login' : formType === 'signup' ? 'Signup' : 'Forgot Password'}</h2>
        <form onSubmit={handleSubmit}>
          {formType === 'signup' && (
            <div className="form-group">
              <label htmlFor="idName">Name</label>
              <input
                id="idName"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          )}
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {formType !== 'forgotPwd' && (
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          )}
          {formType === 'signup' && (
            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>
          )}
          {error && <p className="error">{error}</p>}
          <button type="submit" style={{ backgroundColor: '#002897' }}>{formType === 'login' ? 'Login' : formType === 'signup' ? 'Signup' : 'Reset'}</button>
          <p className="switch-form" onClick={onSwitch}>
            {formType === 'login' ? 'Don\'t have an account yet? Create' : 'Already have an account? Login'}
          </p>
          <p className="switch-form" onClick={onForgotPwd}>Forgot Password </p>
        </form>
      </div>
    </div>
  );
};

export default AuthForm;
